import contentSettings from '@site/content.settings'

export default ({}, inject) => {
  // Inject contentSettings to context
  inject('contentSettings', contentSettings || {})
}
